




























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
let uniqueId = 0;

@Component
export default class extends Vue {
  @Prop({
    default: () => {
      return `button-checkbox-${uniqueId++}`;
    },
  })
  public id!: string;
  @Prop({ default: false })
  public value!: boolean;

  private get active(): boolean {
    return Boolean(this.localValue) || false;
  }

  private localValue = false;
  created() {
    this.onValueChange();
  }

  public mounted() {
    this.onValueChange();
  }

  private onChange(): void {
    this.emitChange();
  }

  @Watch('value')
  private onValueChange() {
    this.localValue = Boolean(this.value);
  }

  @Emit('change')
  private emitChange(): boolean {
    return this.localValue;
  }
}
